/**
 * Check if parent element is OR contains child element
 */
export const contains = (parent: HTMLElement | null, child: Node | null) => {
  if (!parent) return false;
  return parent === child || parent.contains(child);
};
